<template>
    <div v-if="cert_data != null">
        <center>
            <v-btn class="button no-display" @click="print"> Print </v-btn>
            <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
        </center>
        <div>
            <div class="main">
                <div style="background-color: white;">
                    <v-row>
                        <v-col cols="12" sm="3" md="3" class="text-center">
                            <img class="logo" v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo"
                                width="120" height="120" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8" class="text-center print-align" style="font-weight: bold;">
                            <span class="pb-0" v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</span>
                            <h2 v-if="cert_data.section_name == 'Primary'">Vishwakarma Vidyalaya English Primary</h2>
                            <div style="font-size: 25px;" v-else-if="cert_data.section_name == 'Secondary'">Vishwakarma
                                Vidyalaya
                                English Secondary</div>
                            <div style="font-size: 25px;" v-else-if="cert_data.section_name == 'Pre-Primary'">
                                Vishwakarma Vidyalaya
                                English Pre-Primary</div>
                            <div style="font-size: 25px;" v-else-if="cert_data.section_name == 'Higher Secondary'">
                                Vishwakarma
                                Vidyalaya English Higher Secondary</div>
                            <div style="font-size: 25px;" v-else>{{ org_basic_data.school_name }}</div>
                            <h2 style="text-decoration: underline;" class="mt-2">Bonafide Certificate</h2>
                            <h3 class="mt-3">To whom so ever it may concern</h3>
                        </v-col>
                    </v-row>
                    <hr style="border: 1px solid black">
                    <div class="middle pa-10">
                        <p class="mt-5">Bonafide No. <b>{{ cert_data.cert_no }}</b></p>
                        <p>This is to certify that :-</p>
                        <p>Miss / Master : <b>{{ cert_data.stud_name }}</b></p>
                        <p>Is/was studying in our school in std. <b>{{ cert_data.std }}</b> Since June - <b>{{
                            cert_data.ay }}</b>
                        </p>

                        <p>As per our General Register No: <b>{{ cert_data.gr_no }}</b> his/her details are as follows
                        </p>
                        <p>Mother's Name : <b>{{ cert_data.mother_name }}</b></p>
                        <p>Nationality : <b>{{ cert_data.nationality }}</b></p>
                        <p>Religion and Caste : <b>{{ cert_data.religion }} {{ cert_data.caste }}</b></p>
                        <p>Place of Birth : <b>{{ cert_data.place_of_birth }}</b></p>
                        <p>Date of Birth : <b>{{ cert_data.dob }}</b></p>
                        <p>Reason : <b>{{ cert_data.reason }}</b></p>
                    </div>
                    <br>
                    <div class="bottom pa-10">
                        <p>Date : <b>{{ cert_data.cert_date }}</b></p>
                        <v-row class="last">
                            <v-col cols="12" sm="6" md="6">Place :<b> Pune </b></v-col>
                            <v-col cols="12" sm="6" md="6" align="center"><b>Stamp and Signature</b></v-col>
                        </v-row>
                    </div>
                    <br>
                </div>
            </div>
        </div>
        <br><br><br>
        <v-card class="box">
            <div class="no-display">
                <center><span>------- Modify -------</span></center>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field style="margin-left: 77px;" label="Student Reason"
                            v-model.trim="cert_data.reason"></v-text-field>
                    </v-col>
                </v-row>
            </div>
        </v-card>

    </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            fetch_loader: false,
            gen_cert_loader: false,
            show_cert_loader: false,
            search: "",
            dialog: false,
            awspath: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            data_list: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            cert_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            show: true,
            org_basic_data: [],
            htmlToPdfOptions: {
                margin: 0,

                filename: `hehehe.pdf`,

                image: {
                    type: "jpeg",
                    quality: 0.98,
                },

                enableLinks: false,

                html2canvas: {
                    scale: 1,
                    useCORS: true,
                },

                jsPDF: {
                    unit: "in",
                    format: "a4",
                    orientation: "landscape",
                },
            },
            progress: 0,
        };
    },
    watch: {
        progress(val) {
            this.$emit("progress", val);
        },
    },
    components: {
        VueHtml2pdf,
        // "pdf-content": PdfContent,
    },
    methods: {
        makePDF() {
            window.html2canvas = html2canvas;
            var doc = new jsPDF("l", "pt", "a4");
            doc.html(document.querySelector("#app"), {
                callback: function (pdf) {
                    pdf.save("mypdf.pdf");
                },
            });
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        close() {
            this.$router.push({ name: "get-Certificate-Report", target: "blank" });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            this.cert_data = JSON.parse(localStorage.getItem("cert_data"));
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
        },
        async exportToPDF() {
            console.log("hi");
            await html2pdf(this.$refs.document, {
                enableLinks: false,
                margin: 0,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 1, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            });
            console.log("hi1");
        },
        generateReport() {
            this.beforeDownload();
            this.$refs.html2Pdf.generatePdf();
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text(
                            "Page " + i + " of " + totalPages,
                            pdf.internal.pageSize.getWidth() * 0.88,
                            pdf.internal.pageSize.getHeight() - 0.3
                        );
                    }
                })
                .save();
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.onload();
    },
};
</script>
<style scoped>
.main {
    margin-left: 15%;
    margin-right: 15%;
}

@media print {

    .logo {
        height: 280px !important;
        width: 280px !important;
    }

    .headers {
        line-height: 170% !important;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
      width: 100% !important;
    } */
    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card,
    .box {
        display: none !important;
    }

    .main {
        width: 2113px !important;
        height: auto;
        font-size: 50.1px;
        padding: 0 !important;
        margin: 0 !important;
        margin-top: -98px !important;
        margin-left: -9px !important;
        margin-bottom: -100px !important;
    }

    .print-align {
        margin-left: -110px !important;
    }

    @page {
        /* margin-top: 0; */
        size: A4 portrait;
        /* size: 25.5in 19in; */
        /* size: 25in 21.5in; */
        size: 15.5in 19.5in !important;
    }

    .bottom {
        margin-top: 150px !important;
    }

    .middle,
    .bottom {
        margin-left: 70px !important;
    }

    h2 {
        font-size: 60px !important;
    }

    .last {
        padding-bottom: 350px !important;
    }

    .middle {
        line-height: 200% !important;
    }
}
</style>